module.exports = __webpack_public_path__ + "img/forumBj.f3ecc5e1.png";